export default __webpack_public_path__ + "72d9dd9b740d7da397da98f300682731.webp";